import React, { useCallback } from 'react';
import propTypes from 'prop-types';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { useSnackBars } from '../../hooks';

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

const FileUploadBox = ({
  onFileChange,
  acceptedFiles,
  boxStyles,
  children,
  inputRef,
}) => {
  const { addAlert } = useSnackBars();

  const handleDrop = useCallback((event) => {
    event.preventDefault();
    event.stopPropagation();

    const { files } = event.dataTransfer;
    if (files.length > 0) {
      const file = files[0];
      const acceptedTypes = acceptedFiles.split(',').map((type) => type.trim());
      const fileExtension = `.${file.name.split('.').pop().toLowerCase()}`;

      if (acceptedTypes.includes(fileExtension)) {
        const cleanEvent = {
          target: {
            files: [file],
            value: file.name
          }
        };
        onFileChange(cleanEvent);
      } else {
        addAlert({
          id: 'invalid-file-type',
          message: `Archivos permitidos: ${acceptedFiles}`,
          severity: 'warning',
          color: 'warning',
        });
      }
    }
  }, [onFileChange, acceptedFiles, addAlert]);

  const handleDragOver = useCallback((event) => {
    event.preventDefault();
    event.stopPropagation();
  }, []);

  return (
    <Box
      component="label"
      sx={boxStyles}
      onDrop={handleDrop}
      onDragOver={handleDragOver}
    >
      {children}
      <VisuallyHiddenInput
        type="file"
        onChange={onFileChange}
        accept={acceptedFiles}
        ref={inputRef} // <-- asignar ref
      />
    </Box>
  );
};

FileUploadBox.propTypes = {
  selectedFile: propTypes.shape({
    name: propTypes.string.isRequired,
    type: propTypes.string.isRequired,
    size: propTypes.number.isRequired,
  }),
  onFileChange: propTypes.func.isRequired,
  acceptedFiles: propTypes.string,
  boxStyles: propTypes.shape({}),
  children: propTypes.node,
  inputRef: propTypes.oneOfType([
    propTypes.func,
    propTypes.object,
  ]),
};

FileUploadBox.defaultProps = {
  selectedFile: null,
  acceptedFiles: '.csv,.xlsx,.xls',
  boxStyles: {},
  children: null,
  inputRef: null,
};

export default FileUploadBox;
